module.exports = __webpack_public_path__ + "img/team_create_icon7.e8cf4f37.png";